import React from 'react';
import { View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Checkbox from '@/components/General/inputs/Checkbox';

/**
 * Renders a `checkbox` schema field (single boolean). Reuses `Checkbox` with
 * the box left-aligned and the field label to its right (standard checkbox
 * layout). The description tooltip is wired through the checkbox's helpText.
 */
const CheckboxField = ({ field, value, onChange, disabled }) => {
    const checked = Boolean(value);

    return (
        <View style={styles.container}>
            <Checkbox
                testID={`form-field-${field.fieldId}`}
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                label={field.label}
                helpText={field.description}
                required={field.required}
            />
        </View>
    );
};

const styles = StyleSheet.create(({ spacing }) => ({
    container: {
        marginVertical: spacing.sm,
    },
}));

export default CheckboxField;
